var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14_1452)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.4853 3.51473C18.2188 1.24819 15.2052 0 12 0C8.79469 0 5.78123 1.24819 3.51473 3.51469C1.24823 5.78119 0 8.79469 0 12C0 15.2054 1.24819 18.2188 3.51473 20.4853C5.78119 22.7518 8.79469 24 12 24C15.2052 24 18.2188 22.7518 20.4853 20.4853C22.7518 18.2188 24 15.2053 24 12C24 8.79464 22.7518 5.78119 20.4853 3.51473ZM17.29 16.2957C17.5645 16.5703 17.5645 17.0155 17.29 17.2901C17.1526 17.4274 16.9727 17.496 16.7928 17.496C16.6129 17.496 16.4329 17.4273 16.2957 17.2901L12 12.9944L7.70433 17.2901C7.56698 17.4274 7.38708 17.496 7.20712 17.496C7.02722 17.496 6.84722 17.4273 6.71002 17.2901C6.43542 17.0155 6.43542 16.5703 6.71002 16.2957L11.0056 12L6.71002 7.70438C6.43542 7.42983 6.43542 6.98461 6.71002 6.71002C6.98456 6.43547 7.42973 6.43547 7.70438 6.71002L12 11.0057L16.2956 6.71002C16.5702 6.43547 17.0154 6.43547 17.29 6.71002C17.5645 6.98456 17.5645 7.42978 17.29 7.70438L12.9943 12L17.29 16.2957Z",
    fill: "#C7C7C7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14_1452"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.1c71f36ea6343f8b5b80fef49c98ec59.svg";
export { ForwardRef as ReactComponent };